import React, { useMemo, useEffect } from 'react';
import { List, Item, Description, NotResults } from './styled';

interface Props {
  dataList: any;
  handleClickItem?: Function;
  handleRefItems?: Function;
  showFirstItems?: number;
  handleKeyDown?: Function;
  message?: boolean;
}

export const SearchResults: React.FC<Props> = ({
  dataList,
  handleClickItem,
  handleRefItems,
  showFirstItems,
  handleKeyDown,
  message
}) => {

  const refSuggestionsList = useMemo(
    () => Array.from({ length: dataList.length }).map(() => React.createRef()),
    [dataList.length]
  );

  useEffect(() => {
    handleRefItems && handleRefItems(refSuggestionsList);
  });

  const createElement = (job?: string) => {
    const element =  `<p><span>${job}</span></p>`;
    return element;
  }

  return (
    <List showFirstItems={showFirstItems} onKeyDown={handleKeyDown}>
      {
        dataList && dataList.length > 0 && dataList.map((element, index) => (
          <Item
            key={index}
            ref={refSuggestionsList[index]}
            data-index={index}
            tabIndex="-1"
            onMouseDown={() => handleClickItem && handleClickItem(index)}
          >
            <Description
              dangerouslySetInnerHTML={
                {
                  __html: createElement(
                    element.name
                  )
                }
              } />
          </Item>
        ))
      }
      { message && <NotResults dangerouslySetInnerHTML={{
                      __html: 'No se encontraron resultados.'
                    }} />}
    </List>
)};

SearchResults.defaultProps = {
  showFirstItems: 2
}
